var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 82.1 28",
    style: {
      enableBackground: "new 0 0 82.1 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,28H0V0h5.3v23.5h11.9V28z M39.1,28H20.9V0h18v4.2h-13v7.6h10.4v4.1H26v7.8h13.1V28z M48.6,28h-5.2V0h17.7v4.3H48.6 v7.6h9.8v4.2h-9.8V28z M74.6,28h-5.4V4.4h-7.4V0h20.3v4.3h-7.4L74.6,28L74.6,28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL);
export default __webpack_public_path__ + "static/media/L.27b47621bf0be642343b363848111fc3.svg";
export { ForwardRef as ReactComponent };